export enum LoginType {
  Password = 'password',
}
